import { combineActions, handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import { pathOr } from 'ramda'

import * as actions from './actions'
import { Locale } from './constants'
import { prefillLocale } from 'utils/translations'
import { InstallOptions } from 'modules/org/constants'
import * as UserActions from 'modules/user/actions'

const finishOnboardingNotification = handleActions({
  [actions.fetchOrgSuccess]: () => true,
}, false)

const handle = handleActions({
  [actions.setHandle]: (state, action) => action.payload,
}, '')

const name = handleActions({
  [actions.createOrgSuccess]: (state, action) => action.payload.response.organization.name,
}, false)

const orgId = handleActions({
  [actions.createOrgSuccess]: (state, action) => action.payload.response.organization.id,
  [actions.fetchOrgSuccess]: (state, action) => action.payload.id,
  [UserActions.fetchUserSuccess]: (state, action) => action.payload.orgId,
}, false)

const color = handleActions({
  [actions.setColor]: (state, action) => action.payload,
  [actions.fetchEmbedSuccess]: (state, action) => pathOr('0176FF', ['configuration','theme', 'backgroundColor'], action.payload)
}, '0176FF')

const uniqueHandle = handleActions({
  [actions.checkUniqueHandleFailed]: () => false,
  [actions.checkUniqueHandleSuccess]: () => true,
}, false)

const createOrgStatus = handleActions({
  [combineActions(
  actions.createOrg,
  actions.createOrgPending,
  actions.createOrgSuccess,
  actions.createOrgFailed,
  )]: (state, action) => action.type,
}, false)

const createOrgError = handleActions({
  [actions.setCreateOrgError]: (state, action) => action.payload.error.response.message,
  [actions.resetOrgError]: (state, action) => action.payload
}, false)

const oauthError = handleActions({
  [actions.setOAuthError]: (state, action) => action.payload
}, false)

const orgUsers = handleActions({
  [actions.fetchOrgUsersSuccess]: (state, action) => action.payload
}, [])

const properties = handleActions({
  [actions.fetchOrgPropertiesSuccess]: (state, action) => action.payload
}, {})

const embed = handleActions({
  [actions.updateEmbedSuccess]: (state, action) => action.payload.response,
  [actions.fetchEmbedSuccess]: (state, action) => action.payload
}, {})

const locale = handleActions({
  [actions.setLocale]: (state, action) => action.payload,
  [actions.fetchEmbedSuccess]: (state, action) => pathOr(Locale.en, ['configuration', 'locale'], action.payload)
}, prefillLocale[navigator.language] || Locale.en)

const iconStyle = handleActions({
  [actions.setIcon]: (state, action) => action.payload,
  [actions.fetchEmbedSuccess]: (state, action) => pathOr('SOLID1', ['configuration', 'theme', 'iconStyle'], action.payload)
}, 'SOLID1')

const welcomeMessage = handleActions({
  [actions.setWelcomeMessage]: (state, action) => action.payload,
}, "")

const installOption = handleActions({
  [actions.setInstallOption] : (state, action) => action.payload,
}, InstallOptions.JAVASCRIPT)

export default combineReducers({
  color,
  orgId,
  uniqueHandle,
  handle,
  createOrgStatus,
  createOrgError,
  oauthError,
  orgUsers,
  properties,
  embed,
  name,
  locale,
  iconStyle,
  welcomeMessage,
  installOption,
  finishOnboardingNotification,
})



// WEBPACK FOOTER //
// ./src/modules/org/reducer.js